var map = {
	"./az/block-768.jpg": "edc5",
	"./be/block-768.jpg": "4526",
	"./en/block-768.jpg": "10edc",
	"./et/block-768.jpg": "4e74",
	"./hy/block-768.jpg": "6327",
	"./ka/block-768.jpg": "eb9b",
	"./kk/block-768.jpg": "8866",
	"./ky/block-768.jpg": "e114",
	"./lt/block-768.jpg": "fb94",
	"./lv/block-768.jpg": "2443",
	"./mn/block-768.jpg": "03be",
	"./ru/block-768.jpg": "dd29",
	"./uz/block-768.jpg": "68f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5035";